import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import * as moment from 'moment';
import { custom } from 'devextreme/ui/dialog';
import { faTruckMoving } from '@fortawesome/free-solid-svg-icons';
import { forkJoin } from "rxjs";
import { UserService } from '../../services/user.service';
import { ProjectService } from '../../../modules/project/_api/services/project.service';
import { TimeService } from '../../../modules/time/_api/services/time.service';
import { LanguageService } from '../../services/language.service';
import { AmsNotifierService } from '../../services/ams-notifier.service';

@Component({
  selector: 'app-grid-expense',
  templateUrl: './grid-expense.component.html',
  styleUrls: ['./grid-expense.component.css']
})
export class GridExpenseComponent implements OnInit {
  columns: any[];
  dataSource: any[];
  tabDataSource = [
    { id: { }, title: 'List' }
  ];
  tabSelectedIndex = 0;
  title = "";
  titleEditTransport: string;
  projectsDataSource: DataSource;
  projectIdsDataSource: any[];//when searching, only search for these projects
  placeholderProjectSelectSearch = this.languageService.LNG("Label.MinThreeCharacters");
  popupVisible = false;
  popupEditTransportVisible = false;
  projectPopupSearchEnabled = true;
  selectedProjectIdPopup: number;
  selectedCustomerIdPopup: number;
  fromCellPopup: any;
  selectedProjectItemPopup: any;
  customerPopupDataSource: DataSource;
  projectsPopupDataSource: DataSource;
  headerFilterData = [];
  labels = {
    Unconfirmed: '',
    Confirmed: '',
    Approved: '',
    ReadySalary: '',
    TransferredSalary: ''
  };
  transport: any;
  isClone: boolean = false;
  cloneData: any;

  @Input() editMode = "batch";
  @Input() useToolbar = true;
  @Input() allowAdding = true;
  @Input() allowUpdating = true;
  @Input() allowDeleting = true;
  @Input() expenseTypeDataSource: any;
  @Input() employeeDataSource: any;
  @Input() allowEditUnconfirmed = true;
  @Input() allowEditConfirmed = true;
  @Input() allowEditApproved = true;
  @Input() visibleIndexProject: number = 5;//Eirik 20.03.20 task 264 - this is shown as index 2 in projectportal
  @Input() showUnconfirmed: boolean = true;
  @Input() showEmployeeColumn: boolean = true;
  @Input() showTransportColumn: boolean = false;
  @Input() selectedEmployeeId: number;
  @Input() newStatusId: number = 3;//Eirik 02.12.19 task 154 - status when inserting time posts
  @Input() newCategoryId: number = 9;//Eirik 02.12.19 task 154 - category when inserting time posts

  @Output() showExpenseGrid = new EventEmitter<boolean>();
  @Output() refresh = new EventEmitter<void>();
  @Output() selectedDetail = new EventEmitter<any>();
  @Output() showDetail = new EventEmitter<boolean>();
  @Output() rowInserting = new EventEmitter<any>();
  @Output() rowUpdating = new EventEmitter<any>();
  @Output() rowRemoving = new EventEmitter<any>();
  @Output() initNewRow = new EventEmitter<any>();
  @Output() copySelectedRows = new EventEmitter<any>();
  @Output() deleteSelectedRows = new EventEmitter<any>();
  @Output() loading = new EventEmitter<boolean>();
  @Output() cellPrepared = new EventEmitter<any>();
  @Output() editingStart = new EventEmitter<any>();

  @ViewChild(DxDataGridComponent) public dxgrid: DxDataGridComponent;

  faTruckMoving = faTruckMoving;

  constructor(private userService: UserService, private projectService: ProjectService, private timeService: TimeService, private languageService: LanguageService, private amsNotifierService: AmsNotifierService) { }

  ngOnInit() {
    this.labels.Unconfirmed = this.languageService.LNG("Label.Unconfirmed");
    this.labels.Confirmed = this.languageService.LNG("Label.Confirmed");
    this.labels.Approved = this.languageService.LNG("Label.Is.Approved");
    this.labels.ReadySalary = this.languageService.LNG("Label.Ready.For.Salary");
    this.labels.TransferredSalary = this.languageService.LNG("Label.Transferred.Salary");
    this.title = this.languageService.LNG("Label.Expense");
    this.titleEditTransport = this.languageService.LNG("Label.Edit") + " " + this.languageService.LNG("Label.Transport");
    this.setLookUps();
    this.popupEditTransportVisible = false;
    this.headerFilterData = [];
    if (this.showUnconfirmed) {
      this.headerFilterData.push( {
        text: this.labels.Unconfirmed,
        value: ["StatusId", "=", 2]
      });
    }
    this.headerFilterData.push( {
      text: this.labels.Confirmed,
      value: ["StatusId", "=", 3]
    });
    this.headerFilterData.push( {
      text: this.labels.Approved,
      value: ["StatusId", "=", 4]
    });
    this.headerFilterData.push( {
      text: this.labels.ReadySalary,
      value: ["StatusId", "=", 5]
    });
    this.headerFilterData.push( {
      text: this.labels.TransferredSalary,
      value: ["StatusId", "=", 99]
    });
  }

  @Input()
  set gridColumns(cols: any[]) {
    this.columns = cols;
  }

  @Input()
  set gridRecords(recs: any[]) {
    this.dataSource = recs;
  }


  loadGridRecords(searchParameters: any, refreshSearchCriterias: boolean = true, showLoadicon = true) {

    if (showLoadicon) {
      this.loading.emit(true);
    }
    this.projectService.getExpenseRecords(searchParameters)
      .subscribe((result: any) => { // success path

        if (refreshSearchCriterias) {
          this.clearDataGridSelections();
        }
        let data = result.Data;
        this.gridRecords = data.ExpenseRecords;
        if (showLoadicon) {
          this.loading.emit(false);
        }
      }, error => { // error path;
        this.loading.emit(false);
      });
  }

  initExpenseGrid(moduleFunctionId: number, refreshSearchCriterias: boolean = true): Promise<boolean> {

    return new Promise(resolve => {
      this.projectService.getExpenseVM(moduleFunctionId)
        .subscribe((result: any) => { // success path

          if (result.IsSuccess) {
            let dataFields = result.Data.DataFieldNames;
            this.columns = [
              { dataField: 'StatusId', caption: "", cellTemplate: "cellTemplateStatus", width: 55, allowEditing: false, calculateSortValue: "StatusId", calculateGroupValue: "StatusDescription", headerFilter: {
                dataSource: this.headerFilterData,
              } },
              { dataField: 'Date', caption: this.languageService.LNG('Label.Date'), width: 175,  dataType:"date", format:"dd.MM.yyyy", sortOrder: 'asc', visible: this.showDataField(dataFields, 'Date'), cellTemplate: "dateCellTemplate", editCellTemplate: "dateEditTemplate",  setCellValue: this.setDateValue, calculateSortValue:"customDateSort" },
              { dataField: 'WeekNo', caption: this.languageService.LNG('Label.Week'), width: 75, allowEditing: false, alignment: "right", visible: this.showDataField(dataFields, 'WeekNo') },
              { dataField: 'Project', caption: this.languageService.LNG('Label.Project'), visible: this.showDataField(dataFields, 'Value'), setCellValue: function(newData, value, currentRowData) {

                  newData.CarrierProjectId = value && value.ProjectId;
                  newData.Project = value && value.ProjectDisplayName;
                  newData.CustomerId = value && value.CustomerId;
                  newData.CarrierId = value && value.CarrierId;
              }, width: 300, editCellTemplate: "projectEditTemplate", visibleIndex: this.visibleIndexProject },
              { dataField: 'EmployeeId', caption: this.languageService.LNG('Label.Employee'), visible: this.showDataField(dataFields, 'EmployeeId'), lookup: {
                dataSource: this.employeeDataSource,
                displayExpr: "FullName",
                valueExpr: "EmployeeId"
              }, width: 150 },
              { dataField: 'ExpenseTypeId', caption: this.languageService.LNG('Label.Expense.Type'), visible: this.showDataField(dataFields, 'ExpenseTypeId'), lookup: {
                dataSource: this.expenseTypeDataSource,
                displayExpr: "Description",
                valueExpr: "ExpenseTypeId"
              }, width: 150},
              { dataField: 'Value', caption: this.languageService.LNG('Label.Value'),  dataType:"number", visible: this.showDataField(dataFields, 'Value'), width: 165 },
               { dataField: 'Comment', caption: this.languageService.LNG('Label.Comment'), visible: this.showDataField(dataFields, 'Comment') },
              { dataField: 'CustomReference', caption: this.languageService.LNG('Label.CustomReference'), visible: this.showDataField(dataFields, 'CustomReference') },
              { caption: this.languageService.LNG('Label.Transport'), visible: this.showTransportColumn, cellTemplate: "transportCellTemplate" },
            ];
            this.showExpenseGrid.emit(true);
            resolve(true);
            // this.loadGridRecords(searchParameters, refreshSearchCriterias);
          }
          else {
            this.showExpenseGrid.emit(false);
            resolve(false);
          }
        }, error => { // error path;
          this.showExpenseGrid.emit(false);
          resolve(false);
        });
    })
  }

  focusDate(e) {
    e.event.target.select();
  }

  setDateValue(newData, value) {

    newData.Date = value && value.Date;
    newData.Date_YYYYMMDD = value && value.Date_YYYYMMDD;
    newData.Date_DayName = value && value.Date_DayName;
    newData.Date_Str = value && value.Date_Str;
    newData.WeekNo = value && value.WeekNo;
  }

  onDateChanged(e, cell) {

    let dt = moment(e.value);
    var nb = moment(dt).locale('nb');
    let dayname = nb.format('dddd');
    let dateDDMMYYYY = nb.format('dddd DD.MM.YYYY');
    let dateYYYYMMDD = nb.format('YYYY-DD-MM');
    let weekno = nb.format('W');
    let dateValue = {
      Date: e.value,
      Date_YYYYMMDD: dateYYYYMMDD,
      Date_DayName: dayname,
      Date_Str: dateDDMMYYYY,
      WeekNo: nb.isValid() ? weekno : "",
    };
    cell.setValue(dateValue);
  }

  //sort datestring as date
  customDateSort (rowData) {

    let date = rowData.Date;
    let date_str = rowData.Date_Str;
    let date_ddmmyyyy = rowData.Date_DDMMYYYY;
    return rowData.Date;
  }

  setProjectValue(newData, value) {

    newData.CarrierProjectId = value && value.ProjectId;
    newData.Project = value && value.ProjectDisplayName;
    newData.CustomerId = value && value.CustomerId;
    newData.CarrierId = value && value.CarrierId;
  }

  onProjectValueChanged(e, cell) {

    let selectedProject = e.component.option("selectedItem");
    if (selectedProject) {
      cell.setValue(selectedProject);
    }
  }

  focusProject(e) {
    e.event.target.select();
  }

  showPopupProject(selectedProjectId, selectedCustomerId, cell) {

    this.popupVisible = true;
    this.selectedProjectIdPopup = selectedProjectId ? selectedProjectId : -1;
    if (selectedProjectId <= 0 || !selectedProjectId) {
      this.selectedCustomerIdPopup = -1;
    }
    this.fromCellPopup = cell;
  }

  onPopupCustomerChanged(e) {

    this.projectPopupSearchEnabled = false;
    // this.projectPopupDataSource.filter(['CustomerId', '=', e.value]);
    this.selectedCustomerIdPopup = e.value;
    this.projectsPopupDataSource.reload();
  }

  onPopupProjectChanged(e) {

    this.selectedCustomerIdPopup = e.selectedItem.CustomerId;
    this.selectedProjectItemPopup = e.selectedItem;
  }

  //when ok is clicked, then set cellvalue using setValue and also set cell.data so that the correct data is displayed in the selectbox
  onClickPopupSelectedProject(e) {

    this.popupVisible = false;
    this.fromCellPopup.setValue(this.selectedProjectItemPopup);

    this.dxgrid.instance.editCell(this.fromCellPopup.rowIndex,0);

  }

  setLookUps() {

    // project
    this.projectsDataSource = new DataSource({
      key: "ProjectId",
      paginate: false, //Eirik 11.08.20 v2.0.31.3 task 318 - when paginate is false the list is not updated when scrolling to the bottom. had an issue where the list added the same projects again when the user scrolled to the bottom of the list
      load: (loadOptions) => {

        if (this.projectIdsDataSource && this.projectIdsDataSource.length > 0) {

          //this.loading.emit(true);
          if (loadOptions.searchValue != null) {
            if (loadOptions.searchValue.length >= 3) {
              return this.projectService.getBySearchTextAndProjectIdsVM(loadOptions.searchValue.toString(), this.projectIdsDataSource).toPromise().then((data: any) => {

                //this.loading.emit(false);
                return data;
              });
            }
            else {

              //this.loading.emit(false);
            }
          }
          else {

            return this.projectService.getByIdsVM(this.projectIdsDataSource).toPromise().then((data: any) => {
              //this.loading.emit(false);
              return data;
            });
          }
        }
        else {
          if (loadOptions.searchValue != null && loadOptions.searchValue.length >= 3) {
            return this.timeService.getProjectsBySearchText(loadOptions.searchValue.toString()).toPromise().then((data: any) => {
              //this.loading.emit(false);
              return data;
            });
          }
        }
      },
      byKey: (key) => {

        if (key > 0) {
          return this.timeService.getProjectSearchBoxById(key).toPromise();
        }
        else {
          let p: any = {
            ProjectId: -1,
            CustomerId: -1,
            ProjectNumber: "",
            ProjectDisplayName: ""
          }
          return p;
        }
      }
    });

    //customer popup
    this.customerPopupDataSource = new DataSource({
      key: 'CustomerId',
      loadMode: "raw",
      load: (loadOptions) => {
        return this.timeService.getCustomers().toPromise();
      },
      byKey: (key) => {
        return this.timeService.getCustomer(key).toPromise();
      }
    });

    //project popup
    this.projectsPopupDataSource = new DataSource({
      key: "ProjectId",
      paginate: false, //Eirik 11.08.20 v2.0.31.3 task 318 - when paginate is false the list is not updated when scrolling to the bottom. had an issue where the list added the same projects again when the user scrolled to the bottom of the list
      load: (loadOptions) => {

        if (loadOptions.searchValue != null && loadOptions.searchValue.length >= 3) {
          //this.loading.emit(true);
          return this.timeService.getProjectsBySearchText(loadOptions.searchValue.toString()).toPromise().then((data: any) => {


            //this.loading.emit(false);

            return data;
          });
        }
        else {
          if (this.selectedCustomerIdPopup > 0) {

            //this.loading.emit(true);
            return this.timeService.getProjectsByCustomerId(this.selectedCustomerIdPopup).toPromise().then((data: any) => {


              //this.loading.emit(false);

              return data;
            });
          }
          else {
            return [];
            //return "";
          }
        }
      },
      byKey: (key) => {

        if (key > 0) {
          return this.timeService.getProjectSearchBoxById(key).toPromise();
        }
        else {
          let p: any = {
            ProjectId: -1,
            CustomerId: -1,
            ProjectNumber: "",
            ProjectDisplayName: "",
            CarrierId: -1,
          }
          return p;
        }
      }
    });
  }

  showDataField(dataFields: any, dataFieldName: string) {
    var visible = false;
    dataFields.forEach(name => {
      if (name === dataFieldName) {
        visible = true;
      }
    });
    return visible;
  }



  onRefresh() {

    this.dxgrid.instance.refresh();
    this.dxgrid.instance.repaint();
    this.refresh.emit();
  }

  onAdd() {
    this.dxgrid.instance.addRow();
  }

  onCloseTab() {
    this.tabDataSource.splice(this.tabSelectedIndex, 1);

    let tabIdx = this.tabDataSource.length - 1;
    if (tabIdx > 0) {
      this.tabSelectedIndex = this.tabDataSource.length - 1;
      this.showDetail.emit(true);
      this.selectedDetail.emit(this.tabDataSource[this.tabSelectedIndex].id);
    } else {
      this.tabSelectedIndex = 0;
      this.showDetail.emit(false);
    }
  }

  onTitleClick(e) {
    this.tabSelectedIndex = e.itemIndex;
    this.showDetail.emit(this.tabSelectedIndex !== 0);
    this.selectedDetail.emit(this.tabDataSource[e.itemIndex].id);
  }

  onTabTemplateClick(data: any) {
    for (let i = 0; i < this.tabDataSource.length; i++) {
      let tab = this.tabDataSource[i];
      if (data === tab.id) {
        return;
      }
    }
    if (data.Code !== undefined) {
      this.tabDataSource.push({ id: data, title: data.Code });
    } else {
      this.tabDataSource.push({ id: data, title: data.Name || data.title || 'No title found' });
    }
  }

  onCellClick(e) {
    if (e.column.dataField !== undefined && !e.row.isEditing) {
      this.selectedDetail.emit(e.key);
      for (let i = 0; i < this.tabDataSource.length; i++) {
        let tab = this.tabDataSource[i];
        if (e.key === tab.id) {
          this.tabSelectedIndex = i;
          this.showDetail.emit(true);
          return;
        }
      }
      if (e.key.TabTitle !== undefined) {
        this.tabDataSource.push({ id: e.key, title: e.key.TabTitle });
      }
      else if (e.key.Code !== undefined) {
        this.tabDataSource.push({ id: e.key, title: e.key.Code });
      } else {
        this.tabDataSource.push({ id: e.key, title: e.key.Name || e.key.title || 'No title found' });
      }
      this.tabSelectedIndex = this.tabDataSource.length - 1;
      this.showDetail.emit(true);
    }
  }

  onToolbarPreparing(e) {
    if (this.allowEditConfirmed || this.allowEditUnconfirmed) {
        e.toolbarOptions.items.unshift( {
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'copy',
                title: this.languageService.LNG("Label.Copy"),
                onClick: this.onCopySelected.bind(this)
            }
        },
        {
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'trash',
                title: this.languageService.LNG("Label.Delete"),
                onClick: this.onDeleteSelected.bind(this)
            }
        });
    }
}

onCopySelected() {

  let selectedRowsData = this.dxgrid.instance.getSelectedRowsData();
  if (selectedRowsData.length > 0) {

    this.copySelectedRows.emit(selectedRowsData);
    for (let i = 0; i < selectedRowsData.length; i++) {
      this.isClone = true;
      this.cloneData = selectedRowsData[i];
      this.dxgrid.instance.addRow();
    }
  }
}

  onDeleteSelected() {

  let myDialog = custom({
    title: this.languageService.LNG("Label.Delete"),
    messageHtml: this.languageService.LNG("Label.Do.You.Want.To.Delete.The.Selected.Rows"),
    buttons: [{
        text: this.languageService.LNG("Label.Yes"),
        onClick: (e) => {
            return true;
        }
    }, {
      text: this.languageService.LNG("Label.No"),
      onClick: (e) => {
          return false;
      }
  },
    ]
  });
  myDialog.show().then((bDelete) => {

    if (bDelete) {

      let selectedRowsData = this.dxgrid.instance.getSelectedRowsData();
      // this.deleteSelectedRows.emit(selectedRowsData);
        let expenseIds: number[] = [];

          if (selectedRowsData.length > 0) {
            this.loading.emit(true);
            for (let i = 0; i < selectedRowsData.length; i++) {
              if (selectedRowsData[i].StatusId === this.newStatusId && selectedRowsData[i].CategoryId === this.newCategoryId) {
                expenseIds.push(selectedRowsData[i].ExpenseId);
              }
            }

            if (expenseIds.length > 0) {
              if (expenseIds.length > 100) {
                let startIndex = 0;
                let endIndex = 100;
                let arrayRequests = [];
                while (endIndex <= expenseIds.length) {
                  let expenseIdsSliced = expenseIds.slice(startIndex, endIndex);
                  if (expenseIdsSliced.length === 0) {
                    break;
                  }

                  let requestDelete = this.projectService.deleteExpenseByExpenseIds(expenseIdsSliced);
                  arrayRequests.push(requestDelete);
                  startIndex = endIndex;
                  endIndex = endIndex + 100 > expenseIds.length ? expenseIds.length : endIndex + 100;
                  if (startIndex > expenseIds.length) {
                    break;
                  }
                }
                forkJoin(arrayRequests).toPromise().then(results => {

                  if (results.length > 0) {
                    for (let i = 0; i < results.length; i++) {
                      let result: any;
                      result = results[i];
                      if (result.Message != null && result.Message.length > 0) {
                        this.amsNotifierService.error(result.Message);
                      }
                    }
                  }
                  this.amsNotifierService.success(this.languageService.LNG("Label.DeletedOK"));
                  this.loading.emit(false);
                  this.refresh.emit();
                  this.dxgrid.selectedRowKeys = [];
                });
              }
              else {
                this.projectService.deleteExpenseByExpenseIds(expenseIds).subscribe((result: any) => { // success path

                  this.amsNotifierService.success(this.languageService.LNG("Label.DeletedOK"));
                  if (result.Message != null && result.Message.length > 0) {
                    this.amsNotifierService.error(result.Message);
                  }
                  this.loading.emit(false);
                  this.refresh.emit();
                  this.dxgrid.selectedRowKeys = [];
                  // this.dataGrid.instance.refresh();
                }, error => { // error path;
                  this.loading.emit(false);
                });
              }
            }
            else {
              this.amsNotifierService.info(this.languageService.LNG("Label.No.Expense.Posts.To.Delete"));
              this.loading.emit(false);
            }
          }
          else {//delete all
            this.amsNotifierService.info(this.languageService.LNG("Label.Please.Select.Rows.To.Delete"));
            this.loading.emit(false);

          }
    }
  });
}


  onCellPrepared(e) {
    this.cellPrepared.emit(e);
  }


  onEditorPreparing(e) {
    if(e.parentType == "dataRow"){

      e.editorOptions.onFocusIn = function(args) {
        const input = args.element.querySelector('.dx-texteditor-input');
        if (input !== null && input !== undefined) {
          input.select();
        }
      }
   }

   if (e.dataField === "Project" || e.dataField === "Comment") {

      if ((e.row.data.StatusId === 4 && !this.allowEditApproved) ||
        (e.row.data.CategoryId === 1 && e.row.data.StatusId === 2 && !this.allowEditUnconfirmed) ||
        (e.row.data.StatusId === 3 && !this.allowEditConfirmed) ||
        (!this.allowEditConfirmed && !this.allowEditUnconfirmed)) {
        e.readOnly = true;
        e.editorOptions.disabled = true;
      }
    }
  }

  onEditingStart(e) {

    var keyValue = e.key;
    if (e.key) {
      if ((e.key.IsTransport) ||
      (!this.userService.account.IsAdmin && e.key.SupervisorId != null && this.userService.account.IsSupervisor && e.key.SupervisorId != this.userService.account.EmployeeId)) {
            e.cancel = true;
      }
    }
    this.editingStart.emit(e);
  }

  // onRowInserting(e) {
  //   this.rowInserting.emit(e.data);
  // }

  onRowInserting(e) {
    const isCanceled = new Promise((resolve) => {
      this.loading.emit(true);
      let employeeId = e.data.EmployeeId ? e.data.EmployeeId : this.selectedEmployeeId;
      if (this.isValid(e.data)) {

        let expense = {
          ExpenseId: -1,
          EmployeeId: employeeId,

          Date_Str: e.data.Date_Str,
          Date: moment(e.data.Date).format(),
          WeekNo: e.data.WeekNo,

          Value: e.data.Value,
          ExpenseTypeId: e.data.ExpenseTypeId,

          StatusId: this.newStatusId,
          CategoryId: this.newCategoryId,

          CarrierId: e.data.CarrierId,
          CarrierProjectId: e.data.CarrierProjectId,//carrierprojectid
          Project: e.data.Project,//project

          Comment: e.data.Comment,
          CustomReference: e.data.CustomReference,
        };

        this.projectService.insertExpense(expense)
          .subscribe((result: any) => { // success path

            this.loading.emit(false);
            if (result.IsSuccess) {
              resolve(false);
              this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
              e.component.cancelEditData();
              this.dxgrid.instance.endUpdate();
              this.dxgrid.instance.refresh();
              this.dxgrid.instance.repaint();
              this.refresh.emit();
              if (result.Message != null && result.Message.length > 0) {
                this.amsNotifierService.error(result.Message);
              }
            }
            else {
              resolve(true);
              this.amsNotifierService.error(result.ErrorMessage);
            }
          }, error => { // error path;
            this.loading.emit(false);
            resolve(true);
          });
      }
      else {
        this.loading.emit(false);
        resolve(true);
      }
    });
    e.cancel = isCanceled;
}


onRowUpdating(e) {

  this.loading.emit(true);
  const isCanceled = new Promise((resolve) => {
    let employeeId = e.newData.EmployeeId ? e.newData.EmployeeId : e.key.EmployeeId;
    let timetypeId = e.newData.TimeTypeId ? e.newData.TimeTypeId : e.key.TimeTypeId;

    let expense = {
      ExpenseId: e.key.ExpenseId,
      EmployeeId: e.newData.EmployeeId ? e.newData.EmployeeId : e.key.EmployeeId,

      Date_Str: e.newData.Date_Str ? e.newData.Date_Str : e.key.Date_Str,
      Date: e.newData.Date ? moment(e.newData.Date).format() : moment(e.key.Date).format(),
      Date_DayName: e.newData.Date_DayName ? e.newData.Date_DayName : e.key.Date_DayName,
      WeekNo: e.newData.WeekNo ? e.newData.WeekNo : e.key.WeekNo,

      Value: e.newData.Value ? e.newData.Value : e.key.Value,
      ExpenseTypeId: e.newData.ExpenseTypeId ? e.newData.ExpenseTypeId : e.key.ExpenseTypeId,

      CarrierId: e.newData.CarrierId ? e.newData.CarrierId : e.key.CarrierId,
      CarrierProjectId: e.newData.CarrierProjectId ? e.newData.CarrierProjectId : e.key.CarrierProjectId,//carrierprojectid
      Project: e.newData.Project ? e.newData.Project : e.key.Project,//project

      Comment: e.newData.Comment ? e.newData.Comment : e.key.Comment,
      CustomReference: e.newData.CustomReference ? e.newData.CustomReference : e.key.CustomReference,
    };

    if (this.isValid(expense)) {
      this.projectService.updateExpense(expense)
        .subscribe((result: any) => { // success path

          this.loading.emit(false);

          if (result.IsSuccess) {
            resolve(false);
            this.amsNotifierService.success(this.languageService.LNG("Label.SavedOK"));
            if (result.Message != null && result.Message.length > 0) {
              this.amsNotifierService.error(result.Message);
            }
            e.component.cancelEditData();
            this.refresh.emit();
          }
          else {
            this.amsNotifierService.error(result.ErrorMessage);
            resolve(true);
          }
        }, error => { // error path;
          resolve(true);
        });
    }
    else {
      this.loading.emit(false);
      resolve(true);
    }
  });
  e.cancel = isCanceled;
}

onRowRemoving(e) {

  this.loading.emit(true);
  this.projectService.deleteExpense(e.key.ExpenseId)
    .subscribe((result: any) => { // success path

      this.amsNotifierService.success(this.languageService.LNG("Label.DeletedOK"));
      if (result.Message != null && result.Message.length > 0) {
        this.amsNotifierService.error(result.Message);
      }
      this.loading.emit(false);
      this.refresh.emit();
      this.dxgrid.instance.refresh();
    }, error => { // error path;
  });
}

onInitNewRow(e) {

  if (!this.isClone) {
    e.data.TimeId = -1;
    if (this.showEmployeeColumn) {
      e.data.EmployeeId = this.selectedEmployeeId;
      // e.data.EmployeeName = this.cloneData.EmployeeName;
    }
  }
  else {
    //clone project and employee
    e.data.EmployeeId = this.cloneData.EmployeeId;
    e.data.EmployeeName = this.cloneData.EmployeeName;
    e.data.Date = this.cloneData.Date;
    e.data.Date_Str = this.cloneData.Date_Str;
    e.data.Date_YYYYMMDD = this.cloneData.Date_YYYYMMDD;
    e.data.WeekNo = this.cloneData.WeekNo;
    e.data.CarrierId = this.cloneData.CarrierId;
    e.data.CarrierProjectId = this.cloneData.CarrierProjectId;
    e.data.Project = this.cloneData.Project;
    e.data.CustomerId = this.cloneData.CustomerId;
    e.data.Value = this.cloneData.Value;
    e.data.ExpenseTypeId = this.cloneData.ExpenseTypeId;
    e.data.ExpenseTypeDisplayName = this.cloneData.ExpenseTypeDisplayName;
    e.data.Comment = this.cloneData.Comment;
    e.data.CustomReference = this.cloneData.CustomReference;
  }
  this.isClone = false;
}

  clearDataGridSelections() {
    this.dxgrid.instance.clearFilter();
    this.dxgrid.instance.clearGrouping();
    this.dxgrid.instance.clearSelection();
    this.dxgrid.instance.clearSorting();
  }

  saveEditData() {
    this.dxgrid.instance.saveEditData();
  }

  cancelEditData() {
    this.dxgrid.instance.cancelEditData();
  }

  hasEditData() {
    return this.dxgrid.instance.hasEditData();
  }

  isValid(data) {

    if (!data.Date || !moment(data.Date).isValid()) {
      this.amsNotifierService.errorWithTimeout(this.languageService.LNG("Please.Select.Date"));
      return false;
    }
    if (!data.CarrierProjectId || data.CarrierProjectId <= 0) {
      this.amsNotifierService.errorWithTimeout(this.languageService.LNG("Please.Select.Project"));
      return false;
    }
    if (this.showEmployeeColumn && (!data.EmployeeId || data.EmployeeId <= 0)) {
      this.amsNotifierService.errorWithTimeout(this.languageService.LNG("Please.Select.Employee"));
      return false;
    }
    if (!data.Value || data.Value <= 0) {
      this.amsNotifierService.errorWithTimeout(this.languageService.LNG("Label.Please.Type.Value"));
      return false;
    }
    if (!data.ExpenseTypeId || data.ExpenseTypeId <= 0) {
      this.amsNotifierService.errorWithTimeout(this.languageService.LNG("Please.Select.ExpenseType"));
      return false;
    }

    return true;
  }

  onOpenTransport(e, data) {

    this.loading.emit(true);
    this.timeService.getTransportFromExpenseId(data.data.ExpenseId).subscribe((result: any) => { // success path

      this.popupEditTransportVisible = true;
      this.loading.emit(false);
      this.transport = result.Data;
      // this.editTransport.transport = result.Data;

    }, error => { // error path;
      this.loading.emit(false);
    });
  }


  @Input()
  set projectIds(ids: any[]) {
    this.projectIdsDataSource = ids;
    if (this.projectsDataSource) {
      this.projectsDataSource.reload();//Eirik 25.09.20 - reload to search with new projects
    }
  }

}
